import { render, staticRenderFns } from "./postComponent.vue?vue&type=template&id=056f65b7&scoped=true"
import script from "./postComponent.vue?vue&type=script&lang=js"
export * from "./postComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056f65b7",
  null
  
)

export default component.exports